export const sourceIdentityV1019 = (row) =>
  `${row.provider_id}:${row.source_id}`;

export const sourceMatchesV1019 = (source, ref) =>
  (source.legacy_source_refs_v114 || []).some(
    member => member.provider_id === ref.provider_id && member.source_id === ref.source_id
  ) || source.source_id === ref.source_id &&
  (source.provider_id === ref.provider_id ||
    (source.legacy_provider_ids_v1019 || []).includes(ref.provider_id));

const factorIdentity = (value) =>
  String(value).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');

export function organizationSourceOverrideV1019(config, source) {
  const rows = config?.source_overrides_v109 || [];
  const exact = rows.find(
    (row) => sourceIdentityV1019(row) === sourceIdentityV1019(source)
  );
  if (exact) return exact;
  const aliases = rows.filter((row) => sourceMatchesV1019(source, row));
  const factors = new Set(
    aliases.map((row) =>
      factorIdentity(row.price_factor || config?.price_factor || '1')
    )
  );
  const conflict =
    typeof source.identity_conflict_v1019 === 'boolean'
      ? source.identity_conflict_v1019
      : factors.size > 1;
  if (!aliases.length && !conflict) return undefined;
  return {
    provider_id: source.provider_id,
    source_id: source.source_id,
    price_factor: aliases[0]?.price_factor,
    disabled: conflict || aliases.some((row) => row.disabled),
    identity_conflict_v1019: Boolean(conflict),
  };
}

export function keySourceOptionsV1019(sources, refs) {
  const candidates = ref => {
    const exact = sources.filter(source => sourceIdentityV1019(source) === sourceIdentityV1019(ref));
    return exact.length ? exact : sources.filter(source => sourceMatchesV1019(source, ref));
  };
  const selected = refs.map((ref) => {
    const matches = candidates(ref);
    return matches.length === 1 ? sourceIdentityV1019(matches[0]) : sourceIdentityV1019(ref);
  });
  const missing = refs.filter((ref) => candidates(ref).length !== 1);
  return { selected: [...new Set(selected)], missing };
}
